function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.6.398a1.2 1.2 0 00-1.2 1.2v1.6a1.2 1.2 0 001.2 1.2H2v3.073a.801.801 0 00-.165.127L.4 9.033a.8.8 0 000 1.131l1.435 1.434a.8.8 0 001.131 0L4.4 10.164a.804.804 0 00.128-.166H7.6v.4a1.2 1.2 0 001.2 1.2h1.6a1.2 1.2 0 001.2-1.2v-1.6a1.2 1.2 0 00-1.2-1.2H8.8a1.2 1.2 0 00-1.2 1.2v.4H4.528a.8.8 0 00-.128-.165L2.966 7.598a.801.801 0 00-.166-.127V4.398h.4a1.2 1.2 0 001.2-1.2v-1.6a1.2 1.2 0 00-1.2-1.2H1.6zm-.4 1.2c0-.22.18-.4.4-.4h1.6c.221 0 .4.18.4.4v1.6a.4.4 0 01-.4.4H1.6a.4.4 0 01-.4-.4v-1.6zm-.234 8L2.4 8.164l1.435 1.434L2.4 11.033.966 9.598zm7.834-1.2h1.6c.221 0 .4.18.4.4v1.6a.4.4 0 01-.4.4H8.8a.4.4 0 01-.4-.4v-1.6c0-.22.18-.4.4-.4z"
});

function SvgLifecycleIconSettingsNav(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgLifecycleIconSettingsNav;